import { useEffect, useState } from "react";
import ModalComponent from "../../CommonComponents/Modal"
import { toast } from "../../CommonComponents/ToastComponent/toast";
import { Table } from "rsuite";
import { approvedAfterRerun, rerunUnmatchedListSupplier } from "../../../redux/actions/vendor";
import { useDispatch } from "react-redux";
import LoaderComponent from "../../CommonComponents/LoaderComponent";
import StickyHeader from "./sticky-header";
import { approvePartnerSubmissionAfterRerun } from "../../../redux/actions/partnerSubmissions";
const { Column, HeaderCell, Cell, Pagination } = Table

const RerunModal = ({ show, selectedVendor, closeRerunModalHandler, showCreateMasterModal, setShowCreateMasterModal, getTableData, page = 'list' }) => {
    const [loader, setLoader] = useState(false)
    const [backdrop, setBackdrop] = useState('static');
    const [rerunResults, setRerunResults] = useState([])
    const [selectedMaster, setSelectedMaster] = useState({
        id: null,
        matchScore: null
    })

    const dispatch = useDispatch()

    const reRunMatcheColumns = [
        { name: 'matchScore', label: 'Match Score' },
        { name: 'type', label: 'Type of Supplier' },
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'address', label: 'Address' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'email', label: 'Email' },
        { name: 'phone', label: 'Phone' },
        { name: 'employerIdNumber', label: 'EIN' },
    ]

    const onApprove = async () => {
        if (!selectedMaster?.id) {
            toast.show({
                title: 'Warning',
                description: 'Please Select Supplier!'
            })
            return
        }

        const selectedSup = rerunResults?.find(sup => sup?.id === selectedMaster.id)
        const masterId = selectedSup?.isMaster ? selectedSup?.id : selectedSup?.masterId

        if (masterId) {
            setLoader(true)
            if (page === 'partnerSubmission') {
                dispatch(approvePartnerSubmissionAfterRerun(selectedVendor?.id, selectedMaster, masterId)).then(async () => {
                    toast.show({
                        title: 'Success',
                        description: 'Partner Submission matched successfully!'
                    })
                    closeRerunModalHandler()
                    getTableData()
                    setLoader(false)
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: `Failed to match Partner Submission!`
                    })
                    setLoader(false)
                })
            } else {
                dispatch(approvedAfterRerun(selectedVendor?.id, selectedMaster, masterId)).then(async () => {
                    toast.show({
                        title: 'Success',
                        description: 'List Supplier matched successfully!'
                    })
                    closeRerunModalHandler()
                    await getTableData(1, 10, 'unmatched', "", "suppliername", "asc")
                    setLoader(false)
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: `Failed to match List Supplier!`
                    })
                    setLoader(false)
                })
            }
        } else {
            toast.show({
                title: 'Danger',
                description: 'The selected supplier is not assigned to any master!'
            })
            return
        }
    }

    const onSelectMaster = (masterId, matchScore) => {
        selectedMaster?.id === masterId ? setSelectedMaster({ id: null, matchScore: null }) : setSelectedMaster({ id: masterId, matchScore: matchScore })
    }

    const SelectorCell = ({ rowData, onSelectMaster, selectedMaster, dataKey, ...props }) => {
        return (
            <Cell {...props} className="table-action" fixed>
                <div className="d-flex column-gap-4">
                    <button type="button" className={`btn btn-green shadow-none select h-100 w-100`} onClick={() => { onSelectMaster(rowData?.id, rowData?.matchScore) }}>{selectedMaster.id !== null && rowData?.id === selectedMaster.id ? 'UnSelect' : 'Select'}</button>
                </div>
            </Cell>
        )
    }

    const headerElements = () => {
        return reRunMatcheColumns.map((col, index) => {
            if (col.name === 'type') {
                return (
                    <Column
                        resizable
                        sortable
                        key={col.name}
                    >

                        <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                        <Cell className='text-black' dataKey={col.name}>
                            {rowData => {
                                let tmpType = !rowData?.isMaster ? 'Child Supplier' : (rowData?.isMaster && rowData?.masterId) ? 'Location Based Supplier' : "Master Supplier"
                                return (
                                    <p title={rowData[col.name]}>{tmpType}</p>
                                )
                            }}

                        </Cell>
                    </Column>
                )
            }

            if (col.name === 'suppliername') {
                return (
                    <Column
                        resizable
                        sortable
                        key={col.name}
                    >

                        <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                        <Cell className='text-black' dataKey={col.name}>
                            {rowData => {
                                let tmpType = !rowData?.isMaster ? 'childSupplier' : (rowData?.isMaster && rowData?.masterId) ? 'locationBasedSupplier' : "masterSupplier"

                                let navLink = tmpType === "masterSupplier" ? `/suppliers/${rowData?.id}` : `/suppliers/relatedsupplier/${rowData?.id}`
                                return (
                                    <a href={navLink} target="_blank" >{rowData?.suppliername} </a>
                                )
                            }}

                        </Cell>
                    </Column>
                )
            }

            return (
                <Column
                    resizable
                    sortable
                    key={col.name}
                >

                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <Cell className='text-black' dataKey={col.name}>
                        {rowData => {
                            return (
                                <p className={col.name === "matchScore" ? 'text-center' : ''} title={rowData[col.name]}>{col.name === "matchScore" ? Math.round(rowData?.matchScore) : rowData[col.name]}</p>
                            )
                        }}

                    </Cell>
                </Column>
            )
        })
    }

    const rerunDbWithSelectedVendor = () => {
        setLoader(true)
        dispatch(rerunUnmatchedListSupplier({ selectedVendor })).then((res) => {
            setLoader(false)
            let tmpResult = []
            if (res.length) {
                res?.forEach(element => {
                    let tmp = { id: element?._source?.id, suppliername: element?._source?.suppliername, address: element?._source?.address1, city: element?._source?.city, state: element?._source?.state, zip: element?._source?.zip, email: element?._source?.email, phone: element?._source?.phone, matchScore: element?._score, isMaster: element?._source?.isMaster, employerIdNumber: element?._source?.employerIdNumber, isMaster: element?._source?.isMaster, masterId: element?._source?.masterId, primaryMasterId: element?._source?.primaryMasterId }
                    tmpResult.push(tmp)
                });
            }
            setRerunResults(tmpResult)
        }).catch(err => {
            setLoader(false)
            toast.show({
                title: 'Warning',
                description: 'Failed to rerun list supplier!'
            })
        })
    }

    useEffect(() => {
        rerunDbWithSelectedVendor()
    }, [])

    return (
        <ModalComponent
            backdrop={backdrop}
            open={show}
            handleClose={closeRerunModalHandler}
            size={`lg`}
        >
            <div className="container w-100 ">
                <h1>Rerun Unmatched Supplier</h1>
                <StickyHeader vendorDetails={selectedVendor} setSearchList={() => { }} setOnClear={() => { }} />
                <div className={`position-relative border border-2 border mt-3 w-100${loader ? ' loading' : ''}`}>
                    {loader && <LoaderComponent />}
                    <Table
                        virtualized={true}
                        height={300}
                        autoHeight={false}
                        affixHeader={true}
                        data={rerunResults}
                        id='unmatched-vendors-table'
                        className='unmatched-vendors-table'

                    >
                        {headerElements()}
                        <Column
                            width={100}
                            fixed="right"
                            key="action"
                        >
                            <HeaderCell className='fw-bold text-black'>Action</HeaderCell>
                            <SelectorCell onSelectMaster={onSelectMaster} selectedMaster={selectedMaster} />
                        </Column>
                    </Table>
                    <div className="unmatched-vendor-table-pagination">
                        <Pagination
                            prev
                            next
                            first={true}
                            last={true}
                            showInfo
                            total={rerunResults.length}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-end column-gap-4 mt-4">
                    <button className="bg-gray rounded clear p-4 pt-2 pb-2 text-white h4 mb-0" onClick={() => { closeRerunModalHandler() }}>Cancel</button>
                    <button className="bg-green rounded search p-4 pt-2 pb-2 text-white h4 mb-0" onClick={() => { setShowCreateMasterModal(true) }}>Create New Master</button>
                    <button className="bg-green rounded search p-4 pt-2 pb-2 text-white h4 mb-0" onClick={onApprove}>Approve</button>
                </div>
            </div>
        </ModalComponent>
    )
}

export default RerunModal